import { useCallback, useEffect, useMemo, useState } from 'react';
import { LayoutContext } from '../TowerLayout/TowerLayoutProvider';
import { useContext } from 'react';

export const useCloudResources = () => {
    const [cloudResourcesBaseUrl, setCloudResourcesBaseUrl] = useState('');
    const [isCloudResourcesConnected, setIsCloudResourcesConnected] = useState<boolean | null>(null);

    const layoutContext = useContext(LayoutContext);
    const isOfflineMode = layoutContext?.isOfflineMode;

    useEffect(() => {
        const syncStorage = () => {
            const baseUrl = localStorage.getItem('cloudResourcesBaseUrl');
            const isConnected = localStorage.getItem('isCloudResourcesConnected') === 'true';
            setCloudResourcesBaseUrl(baseUrl || '');

            // If layout context is not available (like in login page), default to not offline
            const effectiveOfflineMode = isOfflineMode ?? false;
            setIsCloudResourcesConnected(effectiveOfflineMode ? false : isConnected);
        };

        syncStorage();

        window.addEventListener('storage', syncStorage);
        return () => {
            window.removeEventListener('storage', syncStorage);
        };
    }, [isOfflineMode]);

    const updateCloudResourcesBaseUrl = useCallback((baseURL: string) => {
        localStorage.setItem('cloudResourcesBaseUrl', baseURL);
        setCloudResourcesBaseUrl(baseURL);
    }, []);

    const updateIsCloudResourcesConnected = useCallback(
        (isConnected: boolean) => {
            localStorage.setItem('isCloudResourcesConnected', isConnected.toString());
            // If layout context is not available (like in login page), default to not offline
            const effectiveOfflineMode = isOfflineMode ?? false;
            setIsCloudResourcesConnected(effectiveOfflineMode ? false : isConnected);
        },
        [isOfflineMode]
    );

    return useMemo(
        () => ({
            updateCloudResourcesBaseUrl,
            cloudResourcesBaseUrl,
            updateIsCloudResourcesConnected,
            isCloudResourcesConnected
        }),
        [updateCloudResourcesBaseUrl, cloudResourcesBaseUrl, updateIsCloudResourcesConnected, isCloudResourcesConnected]
    );
};
